const MerchantSettingKey = {
    HAS_POLE_DISPLAY        : 'has_pole_display',
    POLE_DISPLAY_DEBUG_MODE : 'pole_display_debug_mode',
    ALLOW_PAY_WITHOUT_CLOSE_TABLE_SESSION: 'allow_pay_without_close_table_session',
    ENABLE_BASIC_MEMBERSHIP_MODULE : 'enable_basic_membership_module',
    IS_QUEUE_NUMBER_PAGE_ENABLED : 'is_queue_number_page_enabled',
    MEMBERSHIP_DEFAULT_EARN_RATE : 'membership_default_earn_rate',
    MEMBERSHIP_DEFAULT_REDEEM_RATE : 'membership_default_redeem_rate',
    MEMBERSHIP_MINIMUM_REDEEM_POINT : 'membership_minimum_redeem_point',
    MEMBERSHIP_MAXIMUM_REDEEM_POINT : 'membership_maximum_redeem_point',
    MEMBERSHIP_REDEEM_POINT_INTERVAL: 'membership_redeem_point_interval',
    IS_KIPLE_FORCE_RM1: 'is_kiple_force_rm1',
    DISABLE_ONLINE_SELF_RENEW: 'disable_online_self_renew',
    TABLE_CANVAS_VIEW_SHOW_TABLE_ACTIVE_TIME: "table_canvas_view_show_table_active_time",
    QUEUE_NUMBER_AUTO_CLOSE_TIMER: "queue_number_auto_close_timer",
    ORDERLAH_APP_PRINTER_MANAGER_DEVICE_ID: "orderlah_app_printer_manager_device_id",
    POS_HIDE_PICKUP_TAB: "pos_hide_pickup_tab",
    APP_SHOW_FLOATING_ACTION_BUTTON: "app_show_floating_action_button",
    ADMIN_ORDER_AUTO_CLOSE_BILL_ON_CONFIRM_ORDER: "admin_order_auto_close_bill_on_confirm_order",
    CLOSE_TABLE_SESSION_ON_ORDER_CONFIRMED: "close_table_session_on_order_confirmed",
    PIN_LOGIN_MODULE_ENABLED: "pin_login_module_enabled",
    ALLOW_VIEW_OTHER_MODULE_BEFORE_POS_LOGIN: "allow_view_other_module_before_pos_login",
    NEED_PIN_LOGIN_TO_OPEN_MENU: "need_pin_login_to_open_menu",
    IS_WORK_SESSION_MODULE_ENABLED: "is_work_session_module_enabled",
    WORK_SESSION_BASIC_MODE: "work_session_basic_mode",
    BILL_REPORT_SHOW_COUNTER_NAME: "bill_report_show_counter_name",
    DASHBOARD_SHOW_DAILY_SALES_STATISTICS: "dashboard_show_daily_sales_statistics",
    DASHBOARD_SHOW_TABLE_OCCUPANCY: "dashboard_show_table_occupancy",
    DASHBOARD_SHOW_FAVOURITE_ORDER: "dashboard_show_favourite_order",
    DASHBOARD_SHOW_SALES_REPORT_CARD: "dashboard_show_sales_report_card",
    DASHBOARD_SHOW_HOURLY_SALES: "dashboard_show_hourly_sales",
    SERVICE_CHARGE_GROUP: "service_charge_group",
    PIN_LOGIN_FIXED_DIGIT_POSITION: "pin_login_fixed_digit_position",
    PARTICIPANT_MARKETPLACE: "participant_marketplace",
    FACEBOOK_PAGE_URL: "facebook_page_url",
    FACEBOOK_PAGE_NAME: "facebook_page_name",
    ASK_USER_NEED_UTENSILS: "ask_user_need_utensils",
    ASK_USER_NEED_UTENSILS_TEXT: "ask_user_need_utensils_text",
    SETTLEMENT_DEFAULT_CASHIER_IS_ORDER_PLACER: "settlement_default_cashier_is_order_placer",
}

export default MerchantSettingKey;